// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__iydFB","buttons":"styles_buttons__zdYV_","pulse":"styles_pulse__88eDb","jump":"styles_jump__ngfKB","wiggle":"styles_wiggle__0B03O"};